module.exports = __webpack_public_path__ + "img/cn_pocket-9.9b3f48b.jpg";